const API_BASE = '/api';

export interface DailyAttemptState {
  date: string;
  attemptsUsed: number;
  purchased: number;
  maxAttempts: number;
  attemptsRemaining: number;
}

function getInitData(): string {
  const tg = (window as any).Telegram?.WebApp;
  return tg?.initData || 'dev_mode';
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const hasBody = options?.body !== undefined && options.body !== null;
  const headers: Record<string, string> = {
    'Authorization': `tma ${getInitData()}`,
    ...(hasBody ? { 'Content-Type': 'application/json' } : {}),
    ...(options?.headers as Record<string, string> | undefined),
  };
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }

  const json = await res.json();
  return json.data ?? json;
}

export const api = {
  getUser: () => request<any>('/user'),
  saveProgress: (levelId: number, moves: number, stars: number) =>
    request<void>('/progress', {
      method: 'POST',
      body: JSON.stringify({ levelId, moves, stars }),
    }),
  getProgress: () => request<any[]>('/progress'),
  getDailyAttempts: () => request<DailyAttemptState>('/daily/attempts'),
  consumeDailyAttempt: () => request<DailyAttemptState>('/daily/attempt', { method: 'POST' }),
  submitDailyScore: (moves: number, timeSeconds: number) =>
    request<void>('/daily/score', {
      method: 'POST',
      body: JSON.stringify({ moves, timeSeconds }),
    }),
  getDailyLeaderboard: () => request<any[]>('/leaderboard/daily'),
  purchase: (itemId: string) =>
    request<any>('/shop/purchase', {
      method: 'POST',
      body: JSON.stringify({ itemId }),
    }),
};
